import { openLegacyPaymentDetails } from '../legacy/PaymentDetails/LegacyPaymentDetails';
import type { OnPaymentMethodVaultedReturn } from '../legacy/PaymentDetails/LegacyPaymentDetails';
import { openPaymentDetailsModal } from './PaymentDetailsModal';
import type { OnSuccessResponse } from './PaymentDetailsModal';
import type { PaymentDetailsProps } from './types';

type PaymentDetailsReturn<T extends boolean> = T extends true
  ? OnSuccessResponse
  : OnPaymentMethodVaultedReturn;

export const openPaymentDetails = <T extends boolean>(
  isLatest: T,
  props: PaymentDetailsProps,
): Promise<PaymentDetailsReturn<T>> => {
  return (isLatest ? openPaymentDetailsModal(props) : openLegacyPaymentDetails(props)) as Promise<
    PaymentDetailsReturn<T>
  >;
};
